import { AgGridReact, DropdownButton, Text, Flex } from "@jsq/ds/core";
import { PaddingIcon } from "~/pages/FundAccounting/Entities/components/CellRenderers/styles_vanilla.css";
import { useRemoveRoleModal } from "../../../UsersTable/components/hooks";
import { RemoveRoleModal } from "../../../UsersTable/components/RemoveRoleModal";
import { RemoveRole } from "../../hooks";
import { buttonContainer } from "../CellComponents/style_vanilla.css";
import { dropdownButton } from "./style_vanilla.css";

export const RemoveRoleButton = ({
  value,
}: AgGridReact.CustomCellRendererProps<unknown, RemoveRole>) => {
  const { isOpen, openModal, onHide, handleRemove, isSubmitting } = useRemoveRoleModal({
    userIds: value?.userId ? [value.userId] : [],
    groupIds: value?.roleId ? [value.roleId] : [],
  });
  return (
    <>
      <Flex
        flexDirection="row"
        alignItems="center"
        justifyContent="flex-end"
        className={buttonContainer}
      >
        <DropdownButton
          data-testid="remove-role-dropdown-button"
          variant="muted"
          align="right"
          disabled={false}
          icon="ellipsis-h"
          buttonClassName={PaddingIcon}
          keepOpen
          usePortal
        >
          <DropdownButton.Action
            eventKey={"remove"}
            data-testid="remove-role-dropdown-button-action"
            onSelect={openModal}
            disabled={false}
          >
            <Text className={dropdownButton}>Remove Canopy role</Text>
          </DropdownButton.Action>
        </DropdownButton>
      </Flex>
      <RemoveRoleModal
        isOpen={isOpen}
        role={value?.role ?? ""}
        fullName={value?.fullName ?? ""}
        onHide={onHide}
        handleRemove={handleRemove}
        isSubmitting={isSubmitting}
      />
    </>
  );
};
